var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllSetScreenGreenStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2419_2722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.204 93.8531V106.187C198.204 156.943 157.032 198.205 106.187 198.205H93.8531C43.0973 198.205 1.83594 157.032 1.83594 106.187V5.74024C1.83594 3.61062 3.6106 1.83594 5.74022 1.83594H106.187C156.943 1.83594 198.204 43.0085 198.204 93.8531Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.184 103.523C128.37 116.123 115.947 128.634 103.347 158.36C101.838 161.909 96.7807 161.909 95.1831 158.36C82.5831 128.545 70.0718 116.123 40.3456 103.523C36.7963 102.014 36.7963 96.9564 40.3456 95.3589C70.1605 82.7589 82.5831 70.2476 95.1831 40.5214C96.692 36.972 101.749 36.972 103.347 40.5214C115.947 70.3363 128.458 82.7589 158.184 95.3589C161.734 96.8678 161.734 101.925 158.184 103.523Z",
    fill: "#C1F700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.768 1.83594H6.18392C3.78259 1.83594 1.83594 3.78259 1.83594 6.18389V193.768C1.83594 196.169 3.78259 198.115 6.18392 198.115H193.768C196.169 198.115 198.115 196.169 198.115 193.768V6.18389C198.115 3.78259 196.169 1.83594 193.768 1.83594Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2419_2722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSetScreenGreenStar);
export default __webpack_public_path__ + "static/media/all-set-screen-green-star.25b1c0b64bc65e06d03e61796b6c10c3.svg";
export { ForwardRef as ReactComponent };